"use client";

import React from "react";
import { MessageSquare, PenTool, Rocket } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
const steps = [{
  num: "1",
  title: "Design Consultation",
  description: "Schedule a free site visit where we assess your space and discuss material options like Trex, wood, or structural concrete.",
  icon: MessageSquare
}, {
  num: "2",
  title: "Permits & Engineering",
  description: "We handle the entire planning phase, including architectural drawings and securing all necessary California building permits.",
  icon: PenTool
}, {
  num: "3",
  title: "Precision Construction",
  description: "Our expert California deck builders bring your vision to life with master craftsmanship and industry-leading structural standards.",
  icon: Rocket
}];
export default function Process() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="194307" id="our-pool-deck-process" className="bg-background py-20 overflow-hidden">
      <div className="container mx-auto px-4 max-w-[1280px]">
        <div ref={headerRef} className={`text-center mb-16 transition-all duration-700 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl font-default font-extrabold uppercase text-foreground tracking-tight">
            Our Proven Build Process
          </h2>
          <div className="w-24 h-1 bg-ring mx-auto mt-6 rounded-full" />
        </div>

        <div ref={gridRef} className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {steps.map((step, i) => {
          const Icon = step.icon;
          return <div key={i} data-index={i} className={`flex flex-col items-center text-center transition-all duration-700 delay-${i * 200} transform ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
                <div className="relative mb-6 flex flex-col items-center justify-center">
                  <span className="text-8xl md:text-9xl font-default font-bold text-primary/5 select-none">
                    {step.num}
                  </span>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="bg-card rounded-full p-4 shadow-md border border-border">
                      <Icon className="w-8 h-8 text-ring" />
                    </div>
                  </div>
                </div>
                
                <h3 className="text-xl font-default font-bold text-foreground mb-4">
                  {step.title}
                </h3>
                
                <p className="text-muted-foreground font-sans leading-relaxed">
                  {step.description}
                </p>
              </div>;
        })}
        </div>

        <div className="mt-16 flex justify-center">
          <Button size="lg" className="rounded-sm px-8 bg-primary hover:bg-primary/90 text-primary-foreground font-default font-bold transition-all shadow-lg" onClick={() => window.location.href = '/HomePage'}>
            Request Free Site Visit
          </Button>
        </div>
      </div>
    </section>;
}